import { z } from 'zod';
export const createSubjectSchema = z.object({
    opposition_id: z.string().uuid('ID de oposición inválido'),
    name: z.string().min(2, 'El nombre debe tener al menos 2 caracteres').max(200),
    description: z.string().max(1000).optional(),
    order_index: z.number().int().min(0).default(0),
});
export const updateSubjectSchema = createSubjectSchema.partial().omit({ opposition_id: true });
export const reorderSubjectsSchema = z.object({
    items: z
        .array(z.object({
        id: z.string().uuid(),
        order_index: z.number().int().min(0),
    }))
        .min(1, 'Se necesita al menos un elemento para reordenar'),
});
//# sourceMappingURL=subject.schema.js.map